import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Dishes } from './dishes';
import { Months } from './months';
import { Autos} from './autos';
import { Comments } from './comments';
import { Finances } from './finances';
import { Adventures } from './adventures';
import { Cards } from './cards';
import { Auth } from './auth';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

export const ConfigureStore = () => {
    const store = createStore(
        combineReducers({
            dishes: Dishes,
            months: Months,
            autos: Autos,
            comments: Comments,
            finances: Finances,
            adventures: Adventures,
            cards: Cards,
            auth: Auth
        }),
        applyMiddleware(thunk, logger)
    );

    return store;
}


// WEBPACK FOOTER //
// ./src/redux/configureStore.js